import Vue from 'vue'
import store from '../../store'
import firebase from 'firebase/app'
import 'firebase/firestore'

export default {
  namespaced: true,
  state () {
    return {
      users: [],
      reference: null,
      initial: {
        key: null,
        email: null,
        name: null,
        sei: null,
        mei: null,
        seiY: null,
        meiY: null,
        birth: null,
        gender: 1,
        avatar: null,
        role: 'teacher',
        registered: false,
        primary: null,
        primaryGroup: null,
        schools: {},
        groups: {},
        corps: {}, // for future use, it's kind of groups, but not class
        enable: true,
        public: true,
        notice: false,
        root: false,
        chatsShare: false,
        chatsCreate: false,
        multi: false,
        theme: 1,
        docs: false,
        order: [],
        accessContact: false,
        chatFilter: false,
        diag: false,
        diagnose: [],
        createdAt: null,
        updatedAt: null
      }
    }
  },
  getters: {
    users (state) {
      return state.users
    },
    reference (state) {
      return state.reference
    },
    initial (state) {
      return state.initial
    }
  },
  mutations: {
    init (state, payload) {
      state.users = payload
    },
    add (state, payload) {
      state.users.push(payload)
    },
    update (state, payload) {
      const index = state.users.findIndex(user => user.key === payload.key)
      if (index !== -1) {
        Vue.set(state.users, index, payload)
      }
    },
    remove (state, payload) {
      const index = state.users.findIndex(user => user.key === payload.key)
      if (index !== -1) {
        state.users.splice(index, 1)
      }
    },
    reference (state, payload) {
      state.reference = payload
    }
  },
  actions: {
    init ({ commit }) {
      return new Promise((resolve) => {
        commit('init', [])
        resolve()
      })
    },
    subscribe ({ commit }, payload) {
      var boot = true
      var temp = []
      return new Promise((resolve, reject) => {
        commit('init', [])
        const db = firebase.firestore()
        var dbRef = db.collection('users')
        var reference = null
        if (payload) {
          reference = dbRef.where('schools.' + payload, '==', true).where('enable', '==', true).onSnapshot(snapshots => {
            if (snapshots.empty) {
              resolve()
            }
            snapshots.docChanges().forEach(change => {
              var data = JSON.parse(JSON.stringify(change.doc.data()))
              if (boot && change.type === 'added') {
                temp.push(data)
              } else if (change.type === 'added') {
                commit('add', data)
              } else if (change.type === 'modified') {
                commit('update', data)
              } else if (change.type === 'removed') {
                commit('remove', data)
              }
            })
            if (boot) {
              boot = false
              commit('init', temp)
            }
            resolve()
          })
        } else {
          reference = dbRef.onSnapshot(snapshots => {
            if (snapshots.empty) {
              resolve()
            }
            snapshots.docChanges().forEach(change => {
              var data = JSON.parse(JSON.stringify(change.doc.data()))
              if (boot && change.type === 'added') {
                temp.push(data)
              } else if (change.type === 'added') {
                commit('add', data)
              } else if (change.type === 'modified') {
                commit('update', data)
              } else if (change.type === 'removed') {
                commit('remove', data)
              }
            })
            if (boot) {
              boot = false
              commit('init', temp)
            }
            resolve()
          })
        }
        commit('reference', reference)
      })
    },
    unSubscribe ({ commit }) {
      var reference = store.getters['users/reference']
      return new Promise((resolve) => {
        if (reference) {
          reference()
          commit('reference', null)
          commit('init', [])
          resolve()
        } else {
          resolve()
        }
      })
    },
    create ({ commit }, payload) {
      return new Promise((resolve) => {
        payload['createdAt'] = parseInt(new Date().getTime())
        payload['updatedAt'] = parseInt(new Date().getTime())
        const db = firebase.firestore()
        db.collection('users').doc(payload.key).set(payload)
          .then(function () {
            const pause = ms => new Promise(resolve => setTimeout(resolve, ms))
            pause(100).then(() => {
              // console.log('Document successfully written!')
              resolve()
            })
          })
          .catch(function (error) {
            if (error) {
              // console.error('Error writing document: ', error)
            }
            resolve()
          })
      })
    },
    write ({ commit }, payload) {
      return new Promise((resolve) => {
        payload.name = payload.sei + ' ' + payload.mei
        const db = firebase.firestore()
        db.collection('users').doc(payload.key).set(payload)
          .then(function () {
            const pause = ms => new Promise(resolve => setTimeout(resolve, ms))
            pause(100).then(() => {
              // console.log('Document successfully written!')
              resolve()
            })
          })
          .catch(function (error) {
            if (error) {
              // console.error('Error writing document: ', error)
            }
            resolve()
          })
      })
    },
    delete ({ commit }, payload) {
      return new Promise((resolve) => {
        const db = firebase.firestore()
        db.collection('users').doc(payload).delete().then(function () {
          // console.log('users deleted', payload)
          resolve()
        }).catch(function (error) {
          if (error) {
            // console.error('Error removing document: ', error)
          }
          resolve()
        })
      })
    }
  }
}
